import type { ComponentProps } from "react"

export type IconCustomPlacepointProps = ComponentProps<"svg">

function IconCustomPlacepoint(props: IconCustomPlacepointProps) {
  const { viewBox = "0 0 72 97", fill = "currentColor", ...svgProps } = props

  return (
    <svg
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M0 17.3026V83.3553L22.174 96.1184L26.0561 93.8816V27.8289L3.88209 15L0 17.3026Z"
        fill={fill}
      />
      <path
        d="M29.9381 0L26.056 2.23684V27.829L45.7955 39.2105V67.9605L49.6776 70.1974L71.8515 57.3684V24.2105L29.9381 0Z"
        fill={fill}
      />
    </svg>
  )
}

export default IconCustomPlacepoint
